import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type AuroraOutcomeValuesProps = {
	name: string;
	value: number;
	displayName: string;
};

type GofacAuroraOutcomeFieldMutationProps = {
	id: number | string;
	values: AuroraOutcomeValuesProps;
	ownerType?: string;
	onSuccessHandler?: Function;
};

const useGofacAuroraOutcomeFieldMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id, values, ownerType }: GofacAuroraOutcomeFieldMutationProps) => {
			return ownerType
				? autoChecklistService.setGofacOwnerAuroraOutcome(
						id,
						values.name,
						ownerType,
				  )
				: autoChecklistService.setGofacMerchantAuroraOutcome(
						id,
						values.name,
				  );
		},
		{
			onSuccess(data, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Field has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGofacAuroraOutcomeFieldMutation;
